import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import _ from "lodash";
import { FC } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";

import { RoutingList } from "../../../../constants";
import { useChangePasswordMutation } from "../../../../generated/graphql";
import useAppStore from "../../../../states/zustand/appStore";
import Navbar from "../../../common/Navbar/Navbar";
import Layout from "../../../common/layouts/Layout";
import styles from "../Profile.module.scss";
import FormikControl from "./common/FormikControl";

const ChangePassword: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const {setLoader} = useAppStore();

  const [changePassword] = useChangePasswordMutation();

  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("Old Password field can not be empty"),
    newPassword: Yup.string().required("New Password field can not be empty"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), ""], "Passwords must match with new password")
      .required("Confirm Password field can not be empty"),
  });
  const onSubmit = async (values: any) => {
    setLoader(true)
    await changePassword({
      variables:{
        oldPassword: values.oldPassword,
        newPassword: values.newPassword
      }
    })
    setLoader(false)

    navigate(RoutingList.profile.index.path)
  };

  return (
    <Layout>
      <Formik
        initialValues={_.cloneDeep(initialValues)}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            // <Form>
            <>
              <Navbar pageTitle={`Change Password`} />
              <Container maxWidth={false}>
                <Form>
                  <Box className={styles.profilePage}>
                    <Grid container sx={{ justifyContent: "center" }}>
                      <Grid item xs={12} md={8}>
                        <Box className={styles.mb20}>
                          <Typography
                            variant="h2"
                            component="h2"
                            className={styles.headingH2}
                          >
                            Change Password
                          </Typography>
                          <Divider />
                        </Box>
                        <Box>
                          {/* <div className="form-group">
                              <label className="mb-1 form-label">
                                Current password
                              </label>
                              <input
                                type="password"
                                className="form-control form-control-sm"
                                name="old-password"
                                placeholder="Enter password"
                              />
                            </div> */}
                          <FormikControl
                            control="input"
                            type="password"
                            label="Old Password"
                            name="oldPassword"
                            className="form-control form-control-sm"
                            placeholder="Enter password"
                          />
                          {/* <div className="form-group">
                              <label className="mb-1 form-label">
                                New password
                              </label>
                              <input
                                type="password"
                                className="form-control form-control-sm"
                                name="new-password"
                                placeholder="New password"
                              />
                            </div> */}
                          <FormikControl
                            control="input"
                            type="password"
                            label="New Password"
                            name="newPassword"
                            className="form-control form-control-sm"
                            placeholder="Enter New password"
                          />
                          {/* <div className="form-group">
                              <label className="mb-1 form-label">
                                Confirm password
                              </label>
                              <input
                                type="password"
                                className="form-control form-control-sm"
                                name="confirm-password"
                                placeholder="Confirm password"
                              />
                            </div> */}
                          <FormikControl
                            control="input"
                            type="password"
                            label="Confirm Password"
                            name="confirmPassword"
                            className="form-control form-control-sm"
                            placeholder="Confirm password"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <Box className="d-flex justify-content-center align-items-center mg-t-60">
                      <Button
                        variant={"outlined"}
                        color={"error"}
                        className="mg-r-10"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant={"outlined"}
                        color={"error"}
                        className="mg-r-10"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <ArrowBack
                          className="mg-r-6"
                          sx={{ width: "1rem", height: "1rem" }}
                        />
                        <span>Back</span>
                      </Button>
                      <Button
                        variant={"contained"}
                        color={"error"}
                        type="submit"
                        disabled={!formik.isValid}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Form>
              </Container>
            </>
            // </Form>
          );
        }}
      </Formik>
    </Layout>
  );
};

export default ChangePassword;
